import {
    ableProps,
    ablePropsInit,
    requiredProps,
    requiredPropsInit,
    validatorProps,
    validatorPropsInit,
    events as baseEvents,
} from '../component-base/props';
export const props = () => [
    ...ableProps,
    ...requiredProps,
    ...validatorProps,
    {
        key: 'placeholder',
        label: '占位文字',
        type: 'string',
    },
    {
        // 约定0为不处理
        key: 'min',
        label: '最少字数',
        type: 'number',
        props: {
            controls: false,
        },
    },
    {
        key: 'errMin',
        label: '最少字数提示文案',
        type: 'string',
    },
    {
        // 约定0为不处理
        key: 'max',
        label: '最大字数',
        type: 'number',
        props: {
            controls: false,
        },
    },
    {
        key: 'errMax',
        label: '最大字数提示文案',
        type: 'string',
    },
    {
        // 空串表示无正则校验
        key: 'pattern',
        label: '校验正则表达式',
        type: 'string',
    },
    {
        key: 'errPattern',
        label: '正则表达式提示文案',
        type: 'string',
    },
];

export const init = () => ({
    ...ablePropsInit,
    ...requiredPropsInit,
    ...validatorPropsInit,
    placeholder: '',
    min: 0,
    errMin: '',
    max: 100,
    errMax: '',
    pattern: '^(?!^\\d{6})(?!^\\d{1,5}$)',
    errPattern: '填写内容不能全是数字',
});

export const name = '文本域';

export const component = 'mobile-general-form-textarea';

export const events = [
    'user-input',
    'change',
    ...baseEvents,
];
